import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useRef,
  } from "react";
  import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
  import { IconPlus } from "@tabler/icons-react";
  import { IconTrash } from "@tabler/icons-react";
import ArticalFrom from "./ArticalFrom";
  
  const Artical = forwardRef(function (props, ref) {
    
    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({});
    const [awards, setAwards] = useState([]);
    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setSubTitle(props.data.subTitle);
        setDescription(props.data.description);
        setPopimgsData(props.data.awards);
      }
    }, [props.data]);
  
    const setPopimgsData = (data) => {
      let awardsData = [];
      data.forEach((item, index) => {
        awardsData.push({
          name: item.name,
          image: item.image,
          imageFile: item.imageFile,
          imageKey: item.imageKey,
          show: index == 0,
          ref: null,
        });
      });
  
      setAwards(awardsData);
    };
  
    const handleAddAward = () => {
      let award = {
        name: "Artical Data " + (awards.length + 1),
        image: null,
        imageFile: null,
        imageKey: "",
        show: awards.length == 0,
        ref: null,
      };
  
      setAwards([...awards, award]);
    };
  
    const showHideAward = (index) => {
      const currentAwards = [...awards];
  
      currentAwards.forEach((award, innerIndex) => {
        if (index == innerIndex)
          award["show"] = !award["show"];
        else
          award["show"] = false;
      });
  
      setAwards(currentAwards);
    };
  
    const deleteAwardHandler = (targetIndex) => {
      const filteredAwards = awards.filter(
        (item, index) => index !== targetIndex
      );
  
      if (filteredAwards.length == 1) {
        filteredAwards[0]["show"] = true;
      }
  
      const deleteAward = awards.filter(
        (item, index) => index === targetIndex
      );
  
      if (deleteAward && deleteAward.length > 0) {
        if (deleteAward[0].imageKey != "")
          props.imageDelete(deleteAward[0].imageKey);
      }
      setAwards(filteredAwards);
    };
  
  
    const validate = () => {
      const errors = {};
      return Object.keys(errors).length === 0;
    };
    const getData = () => {
      let awardData = [];
      awards.forEach(award => {
        let data = award.ref?.getData() ?? null;
        if (data)
          awardData.push(data);
      });
      return {
        title: title,
        subTitle: subTitle,
        description: description,
        awards: awardData
      };
    }
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate, 
    }));
  
    return (
      <>
        <div className="content d-block visible">
          <div className="content-header mb-3 d-flex justify-content-between">
            <div className="sec-titler">
              <h2 className="text-primary">Artical Page</h2>
              <div className="title-shape"></div>
              <small className="fs-11 mb-0"></small>
            </div>
            <div className="mb-0 text-right">
              <button
                className="btn btn-primary align-middle"
                onClick={handleAddAward}
              >
                <IconPlus className="me-sm-1 me-0" size={20} />
                Add Artical
              </button>
            </div>
            
          </div>
          <form>
          <div className="row g-3">
            <div className="col-sm-6">
              <label className="form-label" htmlFor="section2Name">
              Artical Heading Title
              </label>
              <input
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control ${errors.title ? "is-invalid" : ""
                  }`}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              // style={{ height: "245px", resize: "none" }}
              />
              {errors.title && (
                <div className="invalid-feedback">{errors.title}</div>
              )}
            </div>


            <div className="col-sm-6">
              <label className="form-label" htmlFor="section1TagLine">
              Artical Sub Heading Title
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Please enter the sub heading title here"
                name="section1TagLine"
                id="section1TagLine"
                value={subTitle}
                onChange={(e) => setSubTitle(e.target.value)}
              />
            </div>
          
           
          </div>
        </form>
      
  
          <div className="accordion mt-3">
            {awards &&
              awards.length > 0 &&
              awards.map((award, index) => {
                return (
                  <ArticalFrom
                    data={award}
                    index={index}
                    showHidePople={showHideAward}
                    deletePeople={deleteAwardHandler}
                    imageDelete={props.imageDelete}
                    key={index}
                    ref={el => award.ref = el}
                  />
                );
              })}
          </div>
  
          <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
          />
        </div>
      </>
    );
  });
  
  export default Artical;
  